<script>
/**
 * 操作列组件
 * @param featureList Function
 * @param row Object 操作行数据
*/

export default {
  name: 'YhFeatureList',
  props: {
    featureList: {
      type: Function,
      default: args => args,
    },
    row: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      class: {
        red: 'button--red',
        blue: 'button--blue',
        green: 'button--green',
      },
    };
  },
  render() {
    const list = this.featureList()
      .map(item => <span
        class={this.class[item.color]}
        onClick={() => item.handler(this.row)}>
        {item.label}
      </span>);
    return <div class="feature-container">{list}</div>;
  },
};
</script>
<style lang="scss">
.feature-container {
  text-align: left;
  font-size: 12px;
}
</style>
